import { DiagnosticEvent } from '~/common/models/alert.model';
import { COMMON_FORM_MESSAGES } from '~/common/utils/form/form.messages';

export const NOTIFICATION_SETTINGS_MESSAGES = {
  //Titles
  'common:setting': 'Setting',
  'common:vehicles': 'Vehicles',
  'common:user_plural': 'Users',
  'common:account': 'Account',
  'common:createNew': 'Create new',
  'common:loading': 'Loading',
  //Notification Card
  'settings:notification.card.vehicle.count': '{{totalCount}} Vehicle',
  'settings:notification.card.form.successMessage': 'Changes saved',
  'settings:notification.card.name.addUser': 'User added',
  'settings:notification.card.name.batchOnboarding': 'Vehicle added',
  'settings:notification.card.name.batchOffboarding': 'Vehicle deleted',
  'settings:notification.card.name.removeUser': 'User removed',
  'settings:notification.card.name.profileUpdates': 'Profile updates',
  'settings:notification.card.name.defaultDiagnostics': 'Default Diagnostics',
  'settings:notification.card.name.vehicleHealthEvents':
    'Vehicle health events',
  'settings:notification.card.name.cameraAdded': 'Camera added',
  'common:edit': 'Edit',
  'settings:notification.card.dialog.delete.title': 'Delete notification',
  'settings:notification.card.dialog.create.successMessage':
    'Notification created',
  'settings:notification.card.dialog.delete.successMessage':
    'Notification deleted',
  'settings:notification.card.dialog.delete.message':
    '{{name}} will be deleted from your notification settings.',
  //Notifications Feed / Poppover
  'settings:notifications.title': 'Notifications',
  'settings:notifications.seeAllNotifications': 'See all notifications',
  'settings:notifications.messages.profileUpdated':
    'Account Profile has been updated.',
  'settings:notification.card.form.updateFailedMessage':
    'Unexpected error while updating, please try again later.',
  //Edit Notification Card Content
  'settings:notification.card.deliveryMethod.title': 'Delivery Method',
  'settings:notification.card.subscribers.title': 'Subscribers',
  'settings:notification.card.subscribers.selectedVehicles':
    'Selected vehicles ({{count}})',
  'settings:notification.card.subscribers.selectVehicles': 'Select vehicles',
  'settings:notification.card.subscribers.noSelectedVehicles':
    'No vehicles selected',
  'settings:notification.card.subscribers.noVehiclesFound': 'No vehicles found',
  'settings:notification.card.deliveryMethod.notificationFeed':
    'Notification feed',
  'settings:notification.card.diagnostics.eventsTitle': 'Events',
  'asset:diagnostics': 'Diagnostics',
  'settings:notification.name': 'Notification name',
  'common:roleList.Fleet Manager_plural': 'Fleet Managers',
  'common:email': 'Email',
  'common:utilization.allVehicles': 'All Vehicles',
  'common:create': 'Create',
  'common:cancel': 'Cancel',
  'common:save': 'Save',
  'common:form.closeDialog': 'Close the dialog',
  'common:form.submitDialog': 'Submit the dialog',
  'common:placeHolder.name': 'Enter Name',
  'common:delete': 'Delete',
  diagnostics: {
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.AIRBAG_SYSTEM}`]:
      'Airbag system',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.EMISSION_SYSTEM}`]:
      'Emissions system',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.ENGINE_AND_TRANSMISSION}`]:
      'Engine and transmission',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.LITHIUM_ION_BATTERY}`]:
      'Lithium ion battery',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.STABILITY_CONTROL_SYSTEM}`]:
      'Stability control system',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.LOW_BATTERY}`]:
      'Vehicle battery',
    [`settings:notification.card.diagnostics.type12Volt.${DiagnosticEvent.LOW_BATTERY}`]:
      '12-volt battery',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.LOW_TIRE_PRESSURE}`]:
      'Tire pressure / sensors',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.ANTILOCK_BRAKING_SYSTEM}`]:
      'Anti-lock braking system',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.LOW_WASHER_FLUID}`]:
      'Washer fluid',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.LOW_BRAKE_FLUID}`]:
      'Brake fluid',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.FLAT_TIRE}`]:
      'Flat tire',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.OIL_LIFE}`]:
      'Oil life',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.BRAKE_PADS}`]:
      'Brake pad',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.ENGINE_AIR_FILTER}`]:
      'Engine air filter',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.ONSTAR_SYSTEM}`]:
      'OnStar system',
    [`settings:notification.card.diagnostics.type.${DiagnosticEvent.ELECTRIC_DRIVE_SYSTEM}`]:
      'Electric drive system',
  },
  errors: {
    ...COMMON_FORM_MESSAGES.errors,
    'common:errors.nameRequired': 'Name is required',
    'settings:notification.card.form.requiredDiagnosticsMessage':
      'Select a diagnostic',
    'settings:notification.card.form.requiredEventMessage':
      'Select a vehicle health event',
    'settings:notification.card.form.requiredDeliveryMethodMessage':
      'Select a delivery method',
    'settings:notification.card.form.requiredSafetyEventSubtypesMessage':
      'Select at least one event',
  },
};
